<template>
  <div class="rankInfo">
    <!--    评级-->
    <div class="nyTit">
      <i/>{{ $t('financingFundDetail.rankTit') }}
      <Sbutton v-if="wareCode && isCpSwitch" class="fr" @click.native="viewProdTrade">{{ $t('btns.productTrade') }}</Sbutton>
    </div>
    <commondity-list v-if="showChart && wareCode && isCpSwitch && !isFirst" ref="commodityChart" @toggleClick = "toggleCommidity"/>

    <div style="padding:20px 0;">
      <el-row v-if="score.buyerScore" :gutter="20" style="padding-bottom:10px;">
        <el-col :span="8">{{ $t('loan.buyerCompany') }}：{{ cicFinancingApplyDraftSnapshot.buyerCompanyName }}</el-col>
        <el-col :span="8">{{ $t('financingFundDetail.rankTit') }}：{{ score.buyerScore }}</el-col>
        <el-col :span="8"><Sbutton class="fr" @click.native="checkLevel(1)">{{ $t('financingAppliForm.lookDetails') }}</Sbutton></el-col>
      </el-row>
      <el-row v-if="score.sellerScore" :gutter="20" style="padding-bottom:10px;">
        <el-col :span="8">{{ $t('loan.salerCompany') }}：{{ cicFinancingApplyDraftSnapshot.sellerCompanyName }}</el-col>
        <el-col :span="8">{{ $t('financingFundDetail.rankTit') }}：{{ score.sellerScore }}</el-col>
        <el-col :span="8"><Sbutton class="fr" @click.native="checkLevel(2)">{{ $t('financingAppliForm.lookDetails') }}</Sbutton></el-col>
      </el-row>
      <el-row v-if="score.categoryScore" :gutter="20" style="padding-bottom:10px;">
        <el-col :span="8"><span v-if="!score.sellerScore">{{ $t('loan.salerCompany') }}：{{ cicFinancingApplyDraftSnapshot.sellerCompanyName }}</span></el-col>
        <el-col :span="8">{{ $t('newrisk.additional_assessment') }}：{{ ratingLevelType(score.categoryScore) }} {{ score.categoryScore }}</el-col>
        <el-col :span="8"><Sbutton class="fr" @click.native="checkLevel(3)">{{ $t('financingAppliForm.lookDetails') }}</Sbutton></el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Sbutton from '../../components/Sbutton'
import commondityList from '@/components/KLineCommondity/index.vue'
export default {
  name: 'RankInfo',
  components: {
    Sbutton,
    commondityList
  },
  props: ['data', 'cicFinancingApplyDraftSnapshot'],
  data() {
    return {
      score: {},
      value: '',
      wareCode: '',
      showChart: '',
      isCpSwitch: false, // 商品走势开关
      isFirst: true // 是否是第一次进入，第一次进入的时候不显示商品走势列表
    }
  },

  mounted() {
    console.log(this.data, this.cicFinancingApplyDraftSnapshot)
    const _this = this
    this.$nextTick(function() {
      _this.wareCode = _this.data.wareCode
      _this.showChart = !!_this.wareCode
      if (_this.showChart) {
        _this.getqlSwitch()
      }
    })
    this.axios.post('/api/zma/risk/getZmaRiskScoreByFlowNum', { flowNumber: this.data.flowNumber }).then(res => {
      if (res.status) {
        this.score = res.data
      } else {
        this.$message.error(this.$t(`error.${res.errorCode}`))
      }
    })
  },
  methods: {
    ratingLevelType(ratingLevel) {
      if (ratingLevel < 40) {
        return 'D'
      } else if (ratingLevel >= 40 && ratingLevel < 60) {
        return 'C'
      } else if (ratingLevel >= 60 && ratingLevel < 80) {
        return 'B'
      } else if (ratingLevel >= 80 && ratingLevel <= 100) {
        return 'A'
      }
    },
    checkLevel(type) {
      if (type != 3) {
        this.$router.push(`/riskAssessmentDetail?id=${this.data.flowNumber}&riskType=${type}&source=1`)
      } else {
        this.$router.push(`/riskCoalDetail?id=${this.data.flowNumber}&riskType=${type}`)
      }
    },
    viewProdTrade() {
      // console.log('viewProdTrade'+this.data);
      // //查看商品走势
      // this.$refs.commondityChartDialog.show(this.wareCode);
      this.showChart = true
      this.isFirst = false
      this.getqlSwitch()
    },
    toggleCommidity() {
      this.$nextTick(() => {
        this.$refs.commodityChart.resetList()
      })
      this.showChart = false
    },

    initCommodity() {
      if (this.isCpSwitch && this.showChart && this.wareCode && !this.isFirst) {
        const param = {
          wareCode: this.wareCode
        }
        this.$nextTick(() => {
          this.$refs.commodityChart.handleInit(param)
        })
      }
    },

    getqlSwitch() {
      const _this = this
      _this.axios.post('/zmacommon/getqlSwitch', {}).then((res) => {
        if (res.status) {
          _this.isCpSwitch = res.data === 1
          _this.initCommodity()
        }
      })
    } // 获取商品走势列表展示开关
  }
}
</script>

<style lang="scss" scoped>
.prodLevel{
  li{
    line-height: 24px;
  }
}
::v-deep.el-col{
  min-height: 1px;
  line-height: 30px;
}
</style>

